import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import './Cube.css';

const fandomNames = [
    "Albert Einstein", "Isaac Newton", "Marie Curie", "Nikola Tesla",
    "Galileo Galilei", "Ada Lovelace", "Stephen Hawking", "Johannes Kepler",
    "Leonardo da Vinci", "Max Planck", "Rachel Carson", "Edwin Hubble",
    "Jane Goodall", "John von Neumann", "Linus Pauling", "Hans Bethe",
    "Paul Dirac", "Barbara McClintock", "Lise Meitner", "Subrahmanyan Chandrasekhar",
    "Katherine Johnson", "Chien-Shiung Wu", "Henrietta Leavitt", "Dorothy Hodgkin", "Emmy Noether"
];


const generateFaceContent = () => {
    return fandomNames.sort(() => 0.5 - Math.random()).slice(0, 50).join(' ');
};

const Cube = () => {
    const controls = useAnimation();

    useEffect(() => {
        controls.start({
            rotateX: 360,
            rotateY: 360,
            rotateZ: 360,
            transition: {
                duration: 10,
                repeat: Infinity,
                ease: 'linear',
            }
        });
    }, [controls]);

    return (
        <div className="scene">
            <motion.div className="cube" animate={controls}>
                <div className="cube__face cube__face--front">{generateFaceContent()}</div>
                <div className="cube__face cube__face--back">{generateFaceContent()}</div>
                <div className="cube__face cube__face--right">{generateFaceContent()}</div>
                <div className="cube__face cube__face--left">{generateFaceContent()}</div>
                <div className="cube__face cube__face--top">{generateFaceContent()}</div>
                <div className="cube__face cube__face--bottom">{generateFaceContent()}</div>
            </motion.div>
        </div>
    );
};

export default Cube;
